module.exports = __webpack_public_path__ + "media/3.0481b47a.wav";